import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const CopyIcon = memo(() => (
    <IconWrapper>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="M7.65 16.7V3.3h10.4v13.4zm.7-.7h9V4h-9zm-3.4 3.4V6.8h.7v11.9h8.9v.7z"
            />
        </svg>
    </IconWrapper>
));
